import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { SessionService } from '../../core/services/session.service';
import { Session } from '../../core/models/session';

@Component({
  selector: 'app-event-session',
  templateUrl: './event-session.component.html',
  styleUrls: ['./event-session.component.css'],
  providers:[SessionService]
})
export class EventSessionComponent implements OnInit {

  @Input() eventId: string;
  @Input()
  set eventSessionId(eventSessionId: number) {
    // console.log(eventSessionId);
    if(eventSessionId) {
        this.eventSessionData.prop = 'session';
        this.sessionService.getSingleSessionList(this.eventId, eventSessionId).subscribe(event => {
          if(event) {
            this.name = event.name;
            console.log(this.name);
          }
        });
      } else {
        this.eventSessionData.prop = 'event';
      }
  }

  @Output() messageEvent = new EventEmitter<EventSessionData>();
  
  sessionList: Array<Session> = new Array();
  eventSessionData = new EventSessionData();
  name = null;
  noList:boolean = false;
  constructor(private sessionService: SessionService) { }

  ngOnInit() {
    this.setSessionList(this.eventId);
  }

  sendSessionId(id,name) { 
    if(name == 'session'){
      this.name = null;
    } else {
      this.name = name;
    }
    this.eventSessionData.sessionId = id;
    this.messageEvent.emit(this.eventSessionData);
  }

  /*setSessionList(id) {
    var x = this.sessionService.getSessionList(id)
      x.snapshotChanges().subscribe(list=>{
        //this.contactIdList = new Array();
        this.sessionList = new Array();
        list.forEach(element =>{
          var y = element.payload.toJSON();
          y["$key"] = element.key;
          this.sessionList.push(y as Session);
          console.log(this.sessionList)
        });
      }); 
      if(!this.sessionList){
        this.noList = true;
      }
    }*/

    setSessionList(id) {
      var x = this.sessionService.getSessionList(id)
        x.snapshotChanges().subscribe(list=>{
            this.sessionList = new Array();
            list.forEach(element =>{
              var y = element.payload.toJSON() as Session;
              if(element.key){
                y["$key"] = element.key;
                this.sessionList[y.position] = (y as Session);
              }
            });
      });
      if(!this.sessionList) {
        this.noList = true;
      }
    }

}

export class EventSessionData{
  prop :string;
  sessionId: string;
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/layout/event-session/event-session.component.ts